import Modal from 'react-bootstrap/Modal'
import OneIcon from 'assets/images/uploader/one.svg'
import TwoIcon from 'assets/images/uploader/two.svg'
import ThreeIcon from 'assets/images/uploader/three.svg'
import classNames from 'classnames'
import { useState } from 'react'
import useSetImage from './hooks/useSetImage'
import useSetCustomImage from './hooks/useSetCustomImage'
interface IModalProps {
    show: boolean
    onHide: () => void
    name: string
    bankBalance: number
    interval: string
    shareValue: number
    dayOfDuetion: number
    type: string
    notificationAnnounce: string
    smsAnnounce: string
    id: string | undefined
    refetch: () => void
    imageId: number
}
export default function ChangeImageModal({
    show,
    onHide,
    name,
    bankBalance,
    interval,
    shareValue,
    dayOfDuetion,
    type,
    notificationAnnounce,
    smsAnnounce,
    id,
    refetch,
    imageId,
}: IModalProps) {
    const [selectedImageId, setSelectedImageId] = useState<number | undefined>(
        undefined
    )
    const [customImage, setCustomImage] = useState<undefined | File>(undefined)
    const { mutate } = useSetImage(refetch)
    const { mutateCustom } = useSetCustomImage(refetch)
    const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedImageId(undefined)
        const { files } = e?.target
        if (files && files[0]) {
            if (id) {
                const payload: { id: number; file: File } = {
                    id: Number(id),
                    file: files[0],
                }
                mutateCustom(payload)
            }
        }

        onHide()
    }
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-sm">
                <img
                    src={OneIcon}
                    alt="one"
                    className={classNames(
                        ' mx-auto p-1 w-20 h-20 my-4 ',
                        selectedImageId === 2 &&
                            'border-1 border-green-1 rounded-full'
                    )}
                    onClick={() => {
                        setCustomImage(undefined)
                        setSelectedImageId(2)
                    }}
                />
                <img
                    src={TwoIcon}
                    alt="two"
                    className={classNames(
                        ' mx-auto p-1  w-20 h-20 my-4 ',
                        selectedImageId === 1 &&
                            'border-1 border-green-1 rounded-full'
                    )}
                    onClick={() => {
                        setCustomImage(undefined)
                        setSelectedImageId(1)
                    }}
                />
                <img
                    src={ThreeIcon}
                    alt="three"
                    className={classNames(
                        ' mx-auto p-1  w-20 h-20 my-4 ',
                        selectedImageId === 3 &&
                            ' border-1 border-green-1 rounded-full'
                    )}
                    onClick={() => {
                        setCustomImage(undefined)
                        setSelectedImageId(3)
                    }}
                />
                <label className=" w-full">
                    <input
                        className="text-sm cursor-pointer w-36 hidden"
                        type="file"
                        multiple
                        accept=".jpg, .jpeg .png"
                        onChange={handleUpload}
                    />
                    <hr className=" w-full text-green-1" />
                    <p className=" text-green-1 my-3">گالری</p>
                    <hr className=" w-full text-green-1" />
                </label>
                <p
                    className=" mt-3 text-green-1"
                    onClick={() => {
                        if (selectedImageId) {
                            const payload: ISettingImagePayload = {
                                id,
                                name,
                                bankBalance,
                                interval,
                                shareValue,
                                dayOfDuetion,
                                type,
                                notificationAnnounce,
                                smsAnnounce,
                                imageId: selectedImageId
                                    ? selectedImageId
                                    : imageId,
                            }
                            mutate(payload)
                        }
                        onHide()
                    }}
                >
                    تایید
                </p>
            </div>
        </Modal>
    )
}
